import * as React from 'react'

function CartIcon(props) {
  return (
    <svg
      width='40'
      height='39'
      viewBox='0 0 40 39'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <circle cx='11.978' cy='35.6224' r='3.37778' fill='black' />
      <circle cx='35.6223' cy='35.6224' r='3.37778' fill='black' />
      <path d='M39 8.6H6.48889L11.1802 25.4889H34.7778L39 8.6Z' fill='black' />
      <path
        d='M1 0C0.447715 0 0 0.447715 0 1C0 1.55228 0.447715 2 1 2V0ZM4.37778 1L5.3413 0.732356L5.13786 0H4.37778V1ZM12.8222 31.4L11.8587 31.6676L12.0621 32.4H12.8222V31.4ZM34.7778 32.4C35.3301 32.4 35.7778 31.9523 35.7778 31.4C35.7778 30.8477 35.3301 30.4 34.7778 30.4V32.4ZM6.48889 8.6L5.52537 8.86764L6.48889 8.6ZM39 8.6L39.9701 8.84254C40.0448 8.54379 39.9777 8.2273 39.7882 7.98459C39.5987 7.74187 39.3079 7.6 39 7.6V8.6ZM34.7778 25.4889V26.4889C35.2366 26.4889 35.6366 26.1766 35.7479 25.7314L34.7778 25.4889ZM11.1802 25.4889L10.2167 25.7565L11.1802 25.4889ZM1 2H4.37778V0H1V2ZM12.8222 32.4H34.7778V30.4H12.8222V32.4ZM3.41426 1.26764L5.52537 8.86764L7.45241 8.33236L5.3413 0.732356L3.41426 1.26764ZM6.48889 9.6H39V7.6H6.48889V9.6ZM38.0299 8.35746L33.8076 25.2464L35.7479 25.7314L39.9701 8.84254L38.0299 8.35746ZM5.52537 8.86764L10.2167 25.7565L12.1438 25.2212L7.45241 8.33236L5.52537 8.86764ZM10.2167 25.7565L11.8587 31.6676L13.7857 31.1324L12.1438 25.2212L10.2167 25.7565ZM34.7778 24.4889H11.1802V26.4889H34.7778V24.4889Z'
        fill='black'
      />
    </svg>
  )
}

export default CartIcon
